import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EditEngagementReport = lazy(() =>
  import("@scenes/EngagementReports/components/EngagementReport/EditEngagementReport").then((module) => ({
    default: module.EditEngagementReport,
  }))
);

export const dashboardEngagementReportsEngagementReportIdNRO: NavigationRoutingObject = {
  Component: EditEngagementReport,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-reports-sidebar-pill-menu-option", "Engagement Reports"),
  pageNameForTracking: () => "Engagement Reports",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "editReporting" });
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/engagement_reports/:appGroupId",
};
